module.exports = __webpack_public_path__ + "img/download_2.ec4f57cb.svg";